import { useRouter } from 'next/router';
import { PageType } from '@hotelplan/graphql.types';
import { getRouteByPageTypeLocale } from '@hotelplan/libs.router-config';
import {
  addQueryParams,
  PRODUCT_PARAMS,
  SEARCH_QUERY_DEFAULT_PARAM,
  SEARCH_QUERY_ORIGIN_PARAM,
} from 'components/domain/search-query';

export default function useBackToSrl() {
  const { push, locale, query } = useRouter();

  // the route where the user will be redirected to
  const searchRoute = getRouteByPageTypeLocale(PageType.Srl, locale);

  if (typeof sessionStorage !== 'undefined') {
    const searchQueryOrigin = sessionStorage.getItem(SEARCH_QUERY_ORIGIN_PARAM);

    const searchRouteOrigin = addQueryParams(searchRoute.builder({}), {
      [SEARCH_QUERY_DEFAULT_PARAM]: searchQueryOrigin,
    });

    if (searchQueryOrigin) {
      // add to url info about the product to be able to open
      // correct accordion and page number on srl page
      const href = addQueryParams(searchRouteOrigin, {
        [PRODUCT_PARAMS]: JSON.stringify({
          geoObjectId: query.geoObjectId?.toString(),
          page: query.page?.toString(),
        }),
      });

      const as = decodeURIComponent(searchRouteOrigin);

      return function () {
        // remove searchQueryOrigin from sessionStorage
        sessionStorage.removeItem(SEARCH_QUERY_ORIGIN_PARAM);

        push(href, as, {
          shallow: true,
          scroll: false,
          locale,
        });
      };
    }
  }

  return null;
}
